import { Chart } from 'chart.js';

export function generatePdfRadarImage(scores, domainMap) {
    return new Promise((resolve) => {
        const canvas = document.createElement('canvas');
        canvas.width = 700;
        canvas.height = 700;
        const ctx = canvas.getContext('2d');

        const labels = Object.keys(scores || {});
        const dataValues = Object.values(scores || {});

        const domainColorMap = {
            Identity: 'rgba(255, 99, 132, 0.15)',
            Readiness: 'rgba(54, 162, 235, 0.15)',
            Execution: 'rgba(255, 206, 86, 0.15)',
            Courage: 'rgba(75, 192, 192, 0.15)'
        };

        const colorfulSectorsPlugin = {
            id: 'colorfulSectors',
            beforeDraw(chart) {
                const { ctx, scales } = chart;
                const rScale = scales.r;
                const cx = rScale.xCenter;
                const cy = rScale.yCenter;

                const total = chart.data.labels.length;
                const angleStep = (Math.PI * 2) / total;
                const radius = rScale.getDistanceFromCenterForValue(rScale.max);

                const grouped = {};

                chart.data.labels.forEach((sub, i) => {
                    const domain = domainMap[sub] || 'Unknown';
                    if (!grouped[domain]) {
                        grouped[domain] = [];
                    }
                    grouped[domain].push(i);
                });

                Object.keys(grouped).forEach((domain) => {
                    const idx = grouped[domain];
                    const start = idx[0];
                    const end = idx[idx.length - 1];

                    const startAngle = start * angleStep - Math.PI / 2;
                    const endAngle = (end + 1) * angleStep - Math.PI / 2;

                    ctx.beginPath();
                    ctx.moveTo(cx, cy);
                    ctx.fillStyle = domainColorMap[domain] || 'rgba(0,0,0,0.05)';
                    ctx.arc(cx, cy, radius, startAngle, endAngle);
                    ctx.closePath();
                    ctx.fill();
                });
            }
        };

        new Chart(ctx, {
            type: 'radar',
            data: {
                labels,
                datasets: [
                    {
                        label: 'Assessment Scores',
                        data: dataValues,
                        backgroundColor: 'rgba(99,102,241,0.2)',
                        borderColor: '#6366f1',
                        borderWidth: 3,
                        pointRadius: 5,
                        pointBackgroundColor: '#6366f1'
                    }
                ]
            },

            options: {
                responsive: false,
                maintainAspectRatio: false,

                animation: {
                    duration: 0,
                    onComplete: () => {
                        // Convert into a image
                        resolve(canvas.toDataURL('image/png'));
                    }
                },

                plugins: {
                    legend: { display: false },
                    colorfulSectors: true,
                    tooltip: { enabled: false }
                },

                scales: {
                    r: {
                        beginAtZero: true,
                        min: 0,
                        max: 5,

                        ticks: { stepSize: 1, showLabelBackdrop: false, color: '#6b7280' },
                        grid: { circular: true, color: 'rgba(0,0,0,0.15)' },
                        angleLines: { color: 'rgba(0,0,0,0.12)' },
                        pointLabels: {
                            display: true,
                            color: '#111827',
                            font: { size: 16, weight: '400' }
                        }
                    }
                }
            },

            plugins: [colorfulSectorsPlugin]
        });
    });
}
